import AppDispatcher from '../dispatchers/AppDispatcher';
import TokenConstants from '../constants/Token';
import Invocation from '../api/Invocation';

var TokenActions = {
    delete: function (token) {
        Invocation.billing.deleteToken(token);
    },

    save: function (callback, billingGroupDefaults) {
        AppDispatcher.handleViewAction({
            actionType: TokenConstants.SAVE,
            billingGroupDefaults,
            callback
        });
    },

    updateCard: function (card) {
        AppDispatcher.handleViewAction({
            actionType: TokenConstants.UPDATE_CARD,
            card: card
        });
    }
};
module.exports = TokenActions;



// WEBPACK FOOTER //
// ./app/actions/TokenActions.js